/**
 * Web sibling of AIAssistantButton.
 *
 * The mobile button is absolutely positioned at the bottom-right of the app
 * root. On the desktop frames the page scrolls and the app root can be taller
 * than the window, so the button is mounted inside a viewport-fixed layer and
 * keeps its bottom-right spot on screen. The mobile component itself is
 * unchanged. Metro never picks `.web.*` files.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { AIAssistantButton as MobileAIAssistantButton } from './AIAssistantButton.js';

export const AIAssistantButton: React.FC = () => (
  <View style={styles.layer} pointerEvents="box-none">
    <MobileAIAssistantButton />
  </View>
);

const styles = StyleSheet.create({
  layer: {
    position: 'fixed' as unknown as 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});

export default AIAssistantButton;
